import { useQuery, UseQueryResult } from '@tanstack/react-query';

import { API_QUERY_KEYS, getCaseDetails, QueryDefaults } from 'api';
import { GetCaseDetailsResponse } from 'types';

export const useCaseDetails = (
  consultationId: number
): UseQueryResult<GetCaseDetailsResponse> =>
  useQuery(
    [API_QUERY_KEYS.getCaseDetails, consultationId],
    () => getCaseDetails(consultationId),
    QueryDefaults
  );
